<template>
    <div class="c-continer">
        <div class="van-overlay" @click="onCancel"></div>
        <div class="u-location">
            <div class="location" v-if="address">
                <van-icon name="location-o"/>
                <span>最新定位：<span class="current-location">{{address}}</span></span>

            </div>
            <div class="location" v-if="currentLocation">
                <van-icon name="location-o"/>
                <span>当前定位：<span class="current-location">{{currentLocation}}</span></span>
            </div>
            <!--            {{ latitude }}-->
            <!--            {{ longitude }}-->

            <div class="c-btn">
                <van-button type="info" class="btnBlue" @click="onConfirm" v-if="address || currentLocation">
                    <span v-if="address">更新</span>
                    <span v-else>提交</span>
                </van-button>
                <div class="refresh" @click="onReplay">
                    <van-icon name="replay"/>
                </div>
            </div>
        </div>
        <Loading v-if="loading"></Loading>
    </div>
</template>

<script>
    import axios from "axios";
    import common from '@/api/common';
    import api from '@/api/fae';
    import Loading from '@/components/Loading';
    import SchLists from "./schLists";
    import SchTable from "./schTable";

    export default {
        name: "locate",
        props: {
            id: Number
        },
        components: { Loading},
        data() {
            return {
                loading: false, // 加载中
                currentLocation: '',
                wx_appId: "",
                wx_timeStamp: "",
                wx_nonceStr: "",
                wx_signature: "",
                wx_location: "",
                up_html: "",
                down_html: "",
                ADMIN: JSON.parse(localStorage.getItem('LS_ADMIN')),
                address: '',
                latitude: '',
                longitude: ''
            }
        },
        async created() {
            this.wx_location = await this.getMap();
			//this.wx_location="113.93041,22.53332";
            await this.getAddress(this.wx_location);
        },
        mounted() {
            this.getComLocate()
        },
        methods: {
            async getMap() {
                return new Promise((resolve, reject) => {
                    let that = this;
					let url = encodeURIComponent(window.location.href); //当前url
                    axios.get("https://mb.cecport.com?sign=1&signurl="+url, {})
                        .then(function (response) {
                            //this.$toast(response.data);
                            var data = response.data.split(',');
                            this.wx_appId = data[0];
                            this.wx_timeStamp = data[1];
                            this.wx_nonceStr = data[2];
                            this.wx_signature = data[3];
                            wx.config({
                                debug: false,
                                appId: this.wx_appId,
                                timestamp: this.wx_timeStamp,
                                nonceStr: this.wx_nonceStr,
                                signature: this.wx_signature,
                                jsApiList: [
                                    'getLocation'
                                ]
                            });
                            wx.ready(function () {
                                wx.getLocation({
                                    type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                                    success: function (res) {
                                        //this.$toast(res);
                                        var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                                        var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                                        //var speed = res.speed; // 速度，以米/每秒计
                                        //var accuracy = res.accuracy; // 位置精度
                                        that.latitude = latitude;
                                        that.longitude = longitude;
                                        resolve(longitude + "," + latitude);
                                    }
                                });
                            });
                            wx.error(function (res) {
                                //reject(false);
                                //alert("error"+JSON.stringify(res))
                                console.log("error" + JSON.stringify(res));
                                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                            });
                        }.bind(this))
                        .catch(function (error) {
                            reject(false);
                            //alert("请求微信--定位--失败"+error);
                            this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')), "请求微信--定位--失败" + error);//记录错误
                            console.log("请求微信--定位--失败" + error);
                        });
                });
            },
            async getAddress_map(user_location) {
                return new Promise((resolve, reject) => {
                    var data = user_location.split(',');
                    var lng = data[0];
                    var lat = data[1];
                    var map = new AMap.Map('container', {
                        center: [lng, lat],
                        zoom: 12,
                        resizeEnable: true
                    });
                    var geocoder = new AMap.Geocoder({
                        city: "010", //城市设为北京，默认：“全国”
                    });
                    var lnglat = lng + "," + lat;
                    geocoder.getAddress(lnglat, function (status, result) {
                        if (status === 'complete' && result.regeocode) {
                            //var address = result.regeocode.formattedAddress;
                            var data = result.regeocode;
                            data["longitude"] = lng;
                            data["latitude"] = lat;
                            //data["longitude"]="114.000222";
                            //data["latitude"]="22.58936";
                            localStorage.setItem('MAP_data', JSON.stringify(data));
                            resolve(true);
                        } else {
                            console.log('高德地图获取地址失败');
                            resolve(false);
                        }
                    });
                });
            },
            async getAddress(user_location) {
                this.loading = true;
                var is_gmap = false;
                is_gmap = await this.getAddress_map(user_location);
				
                //this.$toast("getAddress"+is_gmap);
                if (is_gmap == true) {
                    this.loading = false;
                    var data = JSON.parse(localStorage.getItem('MAP_data'));
                    this.currentLocation = data.formattedAddress
                    //定位成功，震动效果
                    if (window.navigator.vibrate) {
                        console.log("你的浏览器支持调用手机震动");
                        window.navigator.vibrate(300);
                    } else {
                        console.log("你的浏览器不支持调用手机震动");
                    }
                } else {
                    this.loading = false;
                    this.$dialog.alert({
                        message: '定位异常，请稍后再试',
                        showConfirmButton: true
                    });
                }

            },
            async onReplay() {
                this.loading = true;
                // $("#loading").show();
                this.wx_location = await this.getMap();//获取定位
                this.getAddress(this.wx_location);
            },
            onConfirm() {
                if(!this.currentLocation){
                    this.$toast("还没定位到地址，请刷新试试！");
                    return;
                }
                let _data = {
                    address: this.currentLocation,
                    latitude: '',
                    longitude: '',
                    id:this.$props.id
                }
                this.$emit('confirm', _data)
            },
            onCancel() {
                this.$emit('cancel')
            },
            getComLocate() {
                if (!this.$props.id) {
                    return
                }
                let entityId = this.CoreNew.SYSTABLE.FAE_CLOCKING;
                let params = {FAE_SUBSCRIBE_ID: this.$props.id};
                common.generalConditionQuery(entityId, params).then(res => {
                    if (res && res.flag && Array.isArray(res.data)) {
                        if (res.data.length > 0) {
                            this.address = res.data[0].ADDRESS;
                        }
                    } else {
                        this.$toast("网络异常，请稍后再试！");
                    }
                })
            },

        }
    }
</script>

<style scoped lang="less">
    .c-continer {
        position: fixed;
        top: 0;
        z-index: 1000;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        overflow: hidden;

        .u-location {
            width: 60%;
            padding: 20px;
            min-height: 100px;
            background: #fff;
            border-radius: 10px;
            position: absolute;
            z-index: 2;
            //left: 50%;
            //top:50%;
            //margin-left: -100px;
            //margin-top: -100px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            .location {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: row;
                font-size: 14px;
                padding: 0 20px 0 10px;
                width: 100%;
                margin-bottom: 20px;

                .van-icon {
                    font-size: 18px;
                }

                .current-location {
                    word-break: break-all;
                }
            }

            .c-btn {
                margin-top: 20px;
                display: flex;
                justify-content: center;
                align-items: center;

                /deep/ .van-button,
                /deep/ button {
                    min-width: 100px;
                    min-height: 40px;
                    height: 40px;
                }

                .refresh {
                    height: 40px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0 10px 0 20px;
                }
            }
        }
    }

</style>